'use client';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
export function SmartBot() {
  const pathname = usePathname();
  useEffect(() => {
    const id = 'mavenoid-script';
    const script = document.getElementById('pre-' + id);
    
    if (!script) {
      console.warn('SmartBot: Pre-script element not found');
      return;
    }

    if (document.getElementById(id)) {
      console.warn('SmartBot: Script already loaded');
      return;
    }

    try {
      const loader = document.createElement('script');
      loader.id = id;
      loader.async = true;
      loader.src = 'https://widget-hosts.mavenoid.com/custom-embedding-scripts/frontpoint-product-selector.js';
      
      // Add error handling
      loader.onerror = (error) => {
        console.error('SmartBot: Failed to load script', error);
      };

      script.parentNode?.insertBefore(loader, script);
      window['mavenoid'] = window['mavenoid'] || [];

      // Cleanup function
      return () => {
        const existingScript = document.getElementById(id);
        if (existingScript) {
          existingScript.remove();
        }
      };
    } catch (error) {
      console.error('SmartBot: Error initializing script', error);
    }
  }, []);

  useEffect(() => {
    const isAddonsPage = pathname.includes('add-ons');
    if (isAddonsPage) {
      document.querySelector('mavenoid-assistant')?.classList.add('hidden');
    } else {
      document.querySelector('mavenoid-assistant')?.classList.remove('hidden');
    }
  }, [pathname]);

  return (
    <>
      <div></div>
      <script id="pre-mavenoid-script"></script>
    </>
  );
}
